var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMrFamilyWarningTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 13.999,
    height: 12.25,
    viewBox: "0 0 13.999 12.25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.99899 0C7.38727 0 7.74548 0.205078 7.94235 0.541406L13.8486 10.6039C14.0482 10.943 14.0482 11.3613 13.8541 11.7004C13.6599 12.0395 13.2963 12.25 12.9052 12.25H1.09274C0.701725 12.25 0.338053 12.0395 0.143913 11.7004C-0.050228 11.3613 -0.0474936 10.9402 0.149381 10.6039L6.05563 0.541406C6.25251 0.205078 6.61071 0 6.99899 0ZM6.99899 3.5C6.63532 3.5 6.34274 3.79258 6.34274 4.15625V7.21875C6.34274 7.58242 6.63532 7.875 6.99899 7.875C7.36266 7.875 7.65524 7.58242 7.65524 7.21875V4.15625C7.65524 3.79258 7.36266 3.5 6.99899 3.5ZM7.87399 9.625C7.87399 9.14102 7.48298 8.75 6.99899 8.75C6.51501 8.75 6.12399 9.14102 6.12399 9.625C6.12399 10.109 6.51501 10.5 6.99899 10.5C7.48298 10.5 7.87399 10.109 7.87399 9.625Z",
    fill: "#D4412D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMrFamilyWarningTriangle);
export default __webpack_public_path__ + "static/media/MrFamily_Warning_Triangle.0e925b16338e57c07381f4d73661b28d.svg";
export { ForwardRef as ReactComponent };